import * as actionTypes from '../types';

export const deleteQuote = {
  flow: (payload: {
    quoteId: number;
    redirectToQuoteList?: boolean;
    onSettledCallback?: () => void;
  }) =>
    ({
      type: actionTypes.QUOTE_DELETE_FLOW,
      payload,
    } as const),
  request: () => ({
    type: actionTypes.QUOTE_DELETE_REQUEST,
  }),
  success: () => ({
    type: actionTypes.QUOTE_DELETE_SUCCESS,
  }),
  error: (payload: { error: unknown }) => ({
    type: actionTypes.QUOTE_DELETE_ERROR,
    payload,
  }),
};
